<header class="flex header p-2">
  <h2>{{ 'Close_Production_Card_Modal_Title' | translateWF: 'Close Production Card' }} - {{ productionCardNumber }}</h2>
</header>

<section class="content p-4">
  <!-- Retained Rolls Summary -->
  @if (closePreview.retainedFabricSummary.length > 0) {
    <h3 class="section-title mb-2">{{ 'Close_PC_Modal_Retained_Rolls' | translateWF: 'Retained Rolls (Finished Goods / Shipped)' }}</h3>
    <p-table [value]="closePreview.retainedFabricSummary" styleClass="p-datatable-sm mb-4">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'Fabric_Code' | translateWF: 'Fabric Code' }}</th>
          <th>{{ 'Description' | translateWF: 'Description' }}</th>
          <th>{{ 'Form' | translateWF: 'Form' }}</th>
          <th>{{ 'Rolls' | translateWF: 'Rolls' }}</th>
          <th>{{ 'Weight_Lbs' | translateWF: 'Weight (lbs)' }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.fabricCode }}</td>
          <td>{{ item.fabricDescription ?? '-' }}</td>
          <td>{{ getFabricFormLabel(item.fabricForm) }}</td>
          <td>{{ item.rollCount }}</td>
          <td>{{ item.totalWeightInLbs | number: '1.2-2' }}</td>
        </tr>
      </ng-template>
    </p-table>
  }

  <!-- Warnings -->
  <div class="flex flex-col gap-2 mb-4">
    <p-message severity="warn" styleClass="w-full">
      {{ 'Close_PC_Modal_No_Final_Weight' | translateWF: 'No final weight can be added after closing.' }}
    </p-message>
    <p-message severity="warn" styleClass="w-full">
      {{ 'Close_PC_Modal_No_Reprocess' | translateWF: 'No reprocess can be initiated after closing.' }}
    </p-message>
  </div>

  <!-- Process Loss Section -->
  <h3 class="section-title mb-2">
    {{ 'Close_PC_Modal_Process_Loss' | translateWF: 'Rolls to be marked as Process Loss' }}
    ({{ closePreview.totalProcessLossRolls }})
  </h3>

  @if (closePreview.processLossFabricSummary.length > 0) {
    <p-table [value]="closePreview.processLossFabricSummary" styleClass="p-datatable-sm mb-3">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'Fabric_Code' | translateWF: 'Fabric Code' }}</th>
          <th>{{ 'Description' | translateWF: 'Description' }}</th>
          <th>{{ 'Form' | translateWF: 'Form' }}</th>
          <th>{{ 'Rolls' | translateWF: 'Rolls' }}</th>
          <th>{{ 'Weight_Lbs' | translateWF: 'Weight (lbs)' }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.fabricCode }}</td>
          <td>{{ item.fabricDescription ?? '-' }}</td>
          <td>{{ getFabricFormLabel(item.fabricForm) }}</td>
          <td>{{ item.rollCount }}</td>
          <td>{{ item.totalWeightInLbs | number: '1.2-2' }}</td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Roll Numbers List -->
    <p-table [value]="closePreview.rollsForProcessLoss" [scrollable]="true" scrollHeight="400px" styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'Roll_Number' | translateWF: 'Roll Number' }}</th>
          <th>{{ 'Fabric' | translateWF: 'Fabric' }}</th>
          <th>{{ 'Location' | translateWF: 'Location' }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-roll>
        <tr>
          <td>{{ roll.number }}</td>
          <td>{{ roll.fabricDescription ?? roll.roll.expectedFabricCode }}</td>
          <td>{{ locationPathService.label(roll.currentLocation.code, roll.currentLocation.name) }}</td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <p class="text-gray-500">{{ 'Close_PC_Modal_No_Process_Loss' | translateWF: 'No rolls will be marked as process loss.' }}</p>
  }
</section>

<footer>
  <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onCancel()" />
  <p-button [label]="'Close_PC_Modal_Confirm' | translateWF: 'Confirm Close'" severity="danger" icon="pi pi-lock" (click)="onConfirm()" />
</footer>
